import styled from 'react-emotion';
var Company = styled('div')({
  display: 'flex',
  fontWeight: 800,
  alignItems: 'center',
  justifyContent: 'flex-start',
  fontSize: '30px'
});
export default Company;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@govuk-react/top-nav/es/atoms/company/index.js
// module id = 112
// module chunks = 0